import { Component, OnInit } from "@angular/core";
import { UserServiceService } from "../../services/user-service/user-service.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-partner",
  templateUrl: "./partner.component.html",
  styleUrls: ["./partner.component.css"],
})
export class PartnerComponent implements OnInit {
  partners: any;

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getPartners();
  }

  getPartners() {
    this.userService.getPartners().subscribe(
      (res: any) => {
        this.partners = res;
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  editPartner(id) {
    return this.router.navigate(["/pages/settings/partners/edit", id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/partner/partner.component.ts